exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".populate-line-item-container {\n    background-color: #F0F0F0;\n}\n::ng-deep .modal-content {\n    border-radius: 0px;\n}\n::ng-deep .modal-body.popup-prop {\n    background-color: #F0F0F0;\n}\nspan.closebtnn{\n    padding-right: 10px;\n}\n.cell-title {\n    padding-top: 0px;\n    text-overflow: ellipsis;\n    width: 100%;\n    font-weight: 100;\n}\ninput[type=\"text\"] {\n    height: 25px;\n    border: none;\n    width: 100%;\n    text-overflow: ellipsis;\n    padding:0 5px;\n    margin-bottom: 20px;\n}\n.cell-disabled {\n    background: #adacac;\n}\n.cell-p{\n    padding: 7px 7px 7px 7px;\n   \n}\n.btn-prop {\n    height: 35px;\n    width: 90px;\n    font-size: 13px;\n    background-color: #12408B;\n    color: #FFFFFF;\n    text-align: center;\n    border-radius: 0;\n    padding: 0 15px;\n    margin-top: 5px;\n}\n.btn-prop:hover {\n    background-color: #EE1C25;\n    border: none;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/runner/work/fbm-fulfillment-wms-client/fbm-fulfillment-wms-client/src/app/shared/lookup/computed-uom-popup/computed-uom-popup.component.css
// module id = ../../../../../src/app/shared/lookup/computed-uom-popup/computed-uom-popup.component.css
// module chunks = main